(function (__dirname){
var stackSlice = require('stack-slice'),
    ignoreDependency = /^\!.+/,
    errorSymbol = '*';

function Step(task, args, done){
    this._task = task;
    this._args = args;
    this._done = done;
}
Step.prototype.run = function(){
    var step = this,
        didError;

    this._task.fn.apply(this, this._args.concat([function(error){
        var result = Array.prototype.slice.call(arguments, 1);
        if(error){
            didError = true;
            step.done(error);
        }else if(!didError){
            step.done(null, result);
        }
    }]));
};
Step.prototype.done = function(error, result){
    if(error){
        if(error instanceof Error){
            stackSlice(error, __dirname, true);
        }
        return this._done(error);
    }
    this._done(null, result);
};

function runTask(task, results, aboutToRun, done, error){
    var names = task.names,
        dependants = task.args,
        args = [];

    if(dependants){
        var useError = dependants[0] === errorSymbol;

        if(useError && !error && dependants.length === 1){
            return;
        }

        for(var i = 0; i < dependants.length; i++) {
            var isErrorDep = dependants[i] === errorSymbol,
                dependantName = dependants[i],
                ignore = dependantName.match(ignoreDependency);

            if(isErrorDep){
                args.push(error);
                continue;
            }

            if(useError && error){
                args.push(undefined);
                continue;
            }

            if(error){
                return;
            }

            if(ignore){
                dependantName = dependantName.slice(1);
            }

            if(!(dependantName in results)){
                return;
            }

            if(!ignore){
                args.push(results[dependantName]);
            }
        }
    }

    var step = new Step(task, args, function(error, results){
        done(names, error, results);
    });

    aboutToRun(names);
    step.run();
}

function run(tasks, results, emitter, error){
    var currentTask,
        noMoreTasks = true;

    if(emitter._complete){
        return;
    }

    for(var key in tasks){
        noMoreTasks = false;
        currentTask = tasks[key];

        runTask(
            currentTask,
            results,
            function(names){
                names.map(function(name){
                    delete tasks[name];
                });
            },
            function(names, taskError, taskResults){
                if(emitter._complete){
                    return;
                }
                if(taskError){
                    run(tasks, results, emitter, taskError);
                    emitter._complete = true;
                    if(!error){
                        emitter.emit('error', taskError, names);
                        emitter.emit('complete');
                    }
                    return;
                }

                for(var i = 0; i < names.length; i++){
                    results[names[i]] = taskResults[i];
                }

                run(tasks, results, emitter);
            },
            error
        );
    }

    if(noMoreTasks && Object.keys(results).length === emitter._taskCount){
        emitter._complete = true;
        emitter.emit('complete');
    }
}

function cloneAndRun(tasks, results, emitter){
    var todo = {},
        hasErrorTask;

    emitter._taskCount = Object.keys(results).length;

    function checkDependencyIsDefined(result, dependencyName){
        dependencyName = dependencyName.match(/\!?(.*)/)[1];

        if(dependencyName !== errorSymbol && !(dependencyName in tasks) && !(dependencyName in results)){
            throw new Error('No task or result has been defined for dependency: ' + dependencyName);
        }

        return result || dependencyName === errorSymbol;
    }

    for(var key in tasks){
        todo[key] = tasks[key];
        emitter._taskCount ++;

        hasErrorTask = tasks[key].args.reduce(checkDependencyIsDefined, false) || hasErrorTask;
    }

    if(hasErrorTask){
        emitter.on('error', function(){});
    }

    run(todo, results, emitter);
}

module.exports = cloneAndRun;
}).call(this,"/node_modules/kgo")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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